export default __webpack_public_path__ + "static/media/ps.e4ca7371.svg";